import { YStack } from '@/components/ui/layout/layout';
import { Text } from '@/components/ui/typography';

const BANNER_BODY =
  'Response cut short after hitting a complexity limit. Try splitting this into smaller, more focused asks.';

export const TurnCapHitBanner = () => (
  <YStack className="w-full px-6 py-2" aria-live="polite">
    <Text size="sm" variant="muted" className="italic">
      ⚠️ {BANNER_BODY}
    </Text>
  </YStack>
);
